<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <SelectInput
        :question="$t('expectations.question')"
        :selections="[
          {
            image: require('@/assets/warning.svg'),
            name: $t('expectations.one'),
            value: 'way-too-expensive'
          },
          {
            image: require('@/assets/empty-cart.svg'),
            name: $t('expectations.two'),
            value: 'a-bit-too-expensive'
          },
          {
            image: require('@/assets/order-confirmed.svg'),
            name: $t('expectations.three'),
            value: 'just-right'
          },
          {
            image: require('@/assets/deliveries.svg'),
            name: $t('expectations.four'),
            value: 'can-afford-more'
          },
          {
            image: require('@/assets/select-house.svg'),
            name: $t('expectations.five'),
            value: 'can-afford-everything'
          }
        ]"
        :selected-value="expectations"
        :clicked-callback="onSelect"
      ></SelectInput>
      <a @click="$router.push(getPrevStepUrl(step))" class="back-btn">{{
        $t("back")
      }}</a>
    </div>
  </div>
</template>

<script>
import SelectInput from "../../components/SelectInput";
import { mapMutations } from "vuex";
import CalculatorHeading from "../../components/CalculatorHeading";
import {
  getStepIndex,
  redirectToUnselectedStepIfAny,
  getPrevStepUrl,
  getNextStepUrl
} from "@/utils/steps.js";

export default {
  name: "Expectations",
  components: { CalculatorHeading, SelectInput },
  data() {
    return {
      step: getStepIndex("expectations"),
      getPrevStepUrl: getPrevStepUrl,
      expectations: this.$store.state.data.expectations
    };
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateExpectations"]),
    onSelect(value) {
      this.expectations = value;
      this.updateExpectations(value);
      setTimeout(
        () => this.$router.push(getNextStepUrl(this.step, this.$i18n.locale)),
        200
      );
    }
  }
};
</script>
